import { provideHttpClient } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { ApplicationConfig } from '@angular/platform-browser';
import { Routes, provideRouter } from '@angular/router';

import { ConfigurationModule } from '@sondermind/configuration';
import { DatadogLoggingModule } from '@sondermind/datadog-logging';
import { LAUNCH_DARKLY_SERVICE, LaunchDarklyService } from '@sondermind/launch-darkly';
import { LoggingInitModule } from '@sondermind/logging-init';
import { ENVIRONMENT } from '@sondermind/utilities/models-environment';
import { WINDOW } from '@sondermind/utilities/tools';

import { EmptyURIValue, URIPrefix } from '@sondermind/features/filter-form';
import { AUTH_SERVICE } from '@sondermind/utilities/models-auth';
import { environment } from '../environments/environment';
import { BrowsePage } from './components/browse-page/browse-page.component';
import { BrowseStatePage } from './components/browse-state-page/browse-state-page.component';
import { DirectoryPage } from './components/directory-page/directory-page.component';
import { RedirectionPage } from './components/redirection-page/redirection-page.component';

const routes: Routes = [
  { path: '', component: RedirectionPage },
  { path: 'browse', component: BrowsePage },
  { path: 'browse/:state', component: BrowseStatePage },
  { path: ':state/:city', component: DirectoryPage },
  { path: ':state/:city/:filters', component: DirectoryPage },
  { path: '**', redirectTo: `${URIPrefix.STATE}-${EmptyURIValue}/${URIPrefix.CITY}-${EmptyURIValue}` }
];

export const APP_CONFIG: ApplicationConfig = {
  providers: [
    provideHttpClient(),
    importProvidersFrom(ConfigurationModule),
    importProvidersFrom(DatadogLoggingModule.forRoot(environment)),
    importProvidersFrom(LoggingInitModule),
    provideRouter(routes),
    { provide: ENVIRONMENT, useValue: environment },
    { provide: LAUNCH_DARKLY_SERVICE, useClass: LaunchDarklyService },
    { provide: WINDOW, useValue: window },
    { provide: AUTH_SERVICE, useValue: { getAuthToken: () => '' } },
  ],
};
